import { motion } from 'framer-motion';
import { FiUsers, FiClock, FiAward, FiTrendingUp } from 'react-icons/fi';

const STATS = [
  { label: 'Aktif Öğrenci', value: '500+', icon: <FiUsers size={20} />, color: 'var(--accent-primary)' },
  { label: 'Toplam Çalışma', value: '10.000+ saat', icon: <FiClock size={20} />, color: 'var(--color-warning)' },
  { label: 'Kazanılan Rozet', value: '2.500+', icon: <FiAward size={20} />, color: 'var(--color-success)' },
  { label: 'Günlük Aktif', value: '120+', icon: <FiTrendingUp size={20} />, color: 'var(--color-info)' },
];

export default function StatsBar() {
  return (
    <section className="stats-bar">
      <div className="stats-grid">
        {STATS.map((stat, i) => (
          <motion.div
            key={i}
            className="stat-item"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
          >
            <span className="stat-icon" style={{ color: stat.color }}>{stat.icon}</span>
            <span className="stat-value">{stat.value}</span>
            <span className="stat-label">{stat.label}</span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
